import React, { useState, useEffect, useRef } from 'react';
import { MOBTexts } from '../contexts/LangMOB';
import ProductMOBFunction from './ProductMOB-function';
import ProductMOBFunction2 from './ProductMOB-function2';
import ProductMOBCertification from './ProductMOB-certification';
import ProductMOBOutline from './ProductMOB-outline';

function ProductMOB({ lang = 'ko' }) {
  const [isMobile, setIsMobile] = useState(false);
  const [certVisible, setCertVisible] = useState(false);
  const certRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setCertVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (certRef.current) {
      observer.observe(certRef.current);
    }

    return () => {
      if (certRef.current) {
        observer.unobserve(certRef.current);
      }
    };
  }, []);
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#FF6B6B', // 바탕색을 #FF6B6B으로 변경
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <h1 style={{
        color: '#fff',
        fontSize: isMobile ? '1.8rem' : '2.5rem',
        fontWeight: 700,
        letterSpacing: '-1px',
        margin: 0,
        marginBottom: isMobile ? 20 : 40,
        textAlign: 'center',
        padding: isMobile ? '0 20px' : '0'
      }}>
        <br /><br />{MOBTexts.title[lang]}
        <br /><span style={{ color: '#FFEB3B' }}>{MOBTexts.subtitle[lang]}</span>
      </h1>
      <ProductMOBOutline lang={lang} isMobile={isMobile} />
      {/* <div style={{ height: isMobile ? '30px' : '50px' }} /> */}
      <ProductMOBFunction2 lang={lang} isMobile={isMobile} />
      {/* <div style={{ height: isMobile ? '30px' : '50px' }} /> */}
      <ProductMOBCertification lang={lang} isMobile={isMobile} certRef={certRef} certVisible={certVisible} />
      {/* <div style={{ height: isMobile ? '30px' : '50px' }} /> */}
    </div>
  );
}

export default ProductMOB;